import { render } from "./EmployeesEmptyState.vue?vue&type=template&id=626bcd24&scoped=true"
import script from "./EmployeesEmptyState.vue?vue&type=script&lang=js"
export * from "./EmployeesEmptyState.vue?vue&type=script&lang=js"

import "./EmployeesEmptyState.vue?vue&type=style&index=0&id=626bcd24&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626bcd24"]])

export default __exports__